import { EditorData } from '~/static/enums/editor-state'
import { ObjectType } from '~/static/enums/object-type'
import { AnyActualProp } from '~/utils/editor/versioning/migrators'
import { loadFonts } from '~/utils/FontsHelper'
import { getCanvasPreview } from './ExportHelper'

export const downloadCard = async (
  data: EditorData,
  name: string,
  width?: number,
  height?: number,
  side?: 'client' | 'server',
): Promise<void> => {
  let serverCompatible = side !== 'client'
  const setServerIncompatible = () => {
    serverCompatible = false
  }

  useNuxtApp().$listen('editor:used-browser-feature', setServerIncompatible)

  data.objects.forEach((objectJson) => {
    const object = jsonParseWithUndefined<AnyActualProp>(objectJson)
    if (object.type === ObjectType.Text && object.fontFamily && object.width) {
      loadFonts([
        {
          fontFamily: object.fontFamily,
          width: object.width,
          italic: object.italic ?? false,
        },
      ])
    }
  })

  useNuxtApp().$off('editor:used-browser-feature', setServerIncompatible)

  let image: Blob
  let imageUrl: string
  if (serverCompatible) {
    image = await $fetch('/api/generate', {
      method: 'post',
      body: { data, width, height },
      responseType: 'blob',
      timeout: 120000,
    })

    imageUrl = URL.createObjectURL(image)
  } else {
    imageUrl = await getCanvasPreview(data, width, height, false)
    image = await (await fetch(imageUrl)).blob()
  }

  // Detect iOS devices
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())

  if (isIOS && typeof navigator.share === 'function' && typeof navigator.canShare === 'function') {
    // Fetch the image as a blob
    const file = new File([ image ], name + '.png', { type: 'image/png' })

    // Check if files can be shared
    if (navigator.canShare({ files: [ file ] })) {
      await navigator.share({
        files: [ file ],
        title: name,
      }).catch((e) => {
        if (e instanceof Error) {
          console.log('Error on ios sharing: ', e.message, e.stack, e)
        } else {
          console.log('Error on ios sharing: ', e)
        }
        throw e
      })
      return
    }
  }

  // Fallback to standard download for non-iOS or if sharing fails
  const link = document.createElement('a')
  link.download = name + '.png'
  link.href = imageUrl
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
